module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-reservation-rate",
    class: _vm.item.status
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [(_vm.$is('listing')) ? _c('card3', {
    staticClass: "add",
    attrs: {
      "showAction": true
    }
  }, [_c('dropdown', {
    attrs: {
      "slot": "actionBullets",
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    },
    slot: "actionBullets"
  }), _c('div', {
    staticClass: "field",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("RR" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "field",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [(_vm.item.time_rate) ? [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("Time cost: " + _vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.time_rate.time_cost)) + "/" + _vm._s(_vm.item.time_rate.time_cost_cycle) + "min")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Driving time cost: " + _vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.time_rate.driving_time_cost)) + "/" + _vm._s(_vm.item.time_rate.time_cost_cycle) + "min")])] : _vm._e()], 2), _c('div', {
    staticClass: "field",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [(_vm.item.distance_rate) ? [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("Distance cost")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.distance_rate.distance_cost)) + "/" + _vm._s(_vm.item.distance_rate.distance_cost_cycle) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])] : _vm._e()], 2), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'configuration-rate',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1de381b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/ReservationRate.vue
// module id = 2189
// module chunks = 1